<script setup lang="ts">
import { ArrowRightIcon } from '@heroicons/vue/20/solid'

const props = withDefaults(defineProps<{
  href?: string
  label?: string
  page: string
  section: string
  destination?: 'stripe' | 'login' | 'feature' | 'anchor'
  variant?: 'primary' | 'secondary' | 'light'
  block?: boolean
}>(), {
  href: undefined,
  label: 'Accéder à l’AppTrident pour 397€/an',
  destination: 'stripe',
  variant: 'primary',
  block: false,
})

const runtimeConfig = useRuntimeConfig()
const route = useRoute()
const { $posthog } = useNuxtApp()

const resolvedHref = computed(() => props.href ?? String(runtimeConfig.public.MARKETING_CHECKOUT_URL))
const isExternal = computed(() => /^https?:\/\//.test(resolvedHref.value))

function trackClick(): void {
  const eventProperties = {
    page: props.page,
    path: route.path,
    section: props.section,
    label: props.label,
    destination: props.destination,
    href: resolvedHref.value,
    ...(props.destination === 'stripe' ? { price: 397 } : {}),
  }

  $posthog?.capture('marketing_cta_clicked', eventProperties)

  if (props.destination === 'stripe') {
    $posthog?.capture('marketing_checkout_started', eventProperties)
  }
}
</script>

<template>
  <NuxtLink
    :to="resolvedHref"
    :external="isExternal"
    :class="[
      'text-balance group inline-flex min-h-11 items-center justify-center gap-2 rounded-xl px-5 py-3 text-sm font-semibold transition-[transform,background-color,color,border-color,box-shadow] duration-200 ease-[cubic-bezier(0.16,1,0.3,1)] hover:-translate-y-0.5 active:translate-y-0 active:scale-[0.98] focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2',
      block ? 'w-full' : '',
      variant === 'primary' ? 'bg-sky-blue-600 text-white shadow-md shadow-sky-blue-900/15 hover:bg-sky-blue-700 focus-visible:ring-sky-blue-500' : '',
      variant === 'secondary' ? 'border border-sky-blue-200 bg-white text-sky-blue-800 shadow-sm hover:border-sky-blue-300 hover:bg-sky-blue-50 focus-visible:ring-sky-blue-500' : '',
      variant === 'light' ? 'bg-white text-sky-blue-900 shadow-md shadow-sky-blue-950/20 hover:bg-sky-blue-50 focus-visible:ring-white' : '',
    ]"
    @click="trackClick"
  >
    <span>{{ label }}</span>
    <ArrowRightIcon class="h-4 w-4 transition-transform group-hover:translate-x-0.5" aria-hidden="true" />
  </NuxtLink>
</template>
